import React, { Component } from 'react'
import { connect } from 'react-redux'

import { withRouter, Link as RouterLink } from 'react-router-dom'

import ContentInfo from '../Steps/_ContentInfo'
import { Container, Row, Col } from '../../../../v2SPRINTA/atoms/Grid'
import css from './style.module.css'
import Display from '../../../../v2SPRINTA/atoms/Display';
import Button from '../../../../v2SPRINTA/atoms/Button';
import FontIcon from '../../../../SPRINTA/atoms/FontIcon';
import ActionBtnIcon from '../../../../SPRINTA/molecules/ActionBtnIcon';
import Tag from '../../../../SPRINTA/atoms/Tag'

import Dialog from '../../../../v2SPRINTA/molecules/Dialog'

import Loading from '../../../../SPRINTA/atoms/Loading'

import { findExperiences, deleteExperience } from '../_utils'

class ExperiencesList extends Component {
    state = {
        list: null,
        dialog: true
    }

    constructor(props) {
        super(props)

        findExperiences()
        .then(resp => {
            let listGym = resp.result.list.filter(item => {
               return item.kind === 'GYM' 
            })
            this.setState({
                list: listGym
            })
        })
    }

    remove(token) {
        this.dialog.confirm("Confirmação", "Deseja realmente deletar essa academia?")
        .then(() => {
            let exps = this.state.list
            let exp = exps.find(i => i.token === token)
            let expInx = exps.indexOf(exp)

            exps[expInx].deleting = true
            this.setState({
                list: exps
            })
            
            deleteExperience(token)
            .then(resp => {
                exps.splice(expInx, 1)
                this.setState({
                    list: exps
                })
            })
        })
    }

    render() {
        if(!this.state.list) 
        return (
            <Container>
                <Row  style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <Col text='center'>
                        <Loading />
                    </Col>
                </Row>
            </Container>
        )

        if(this.state.list.length < 1) return null;

        return (
            <div className={css.box}>
                <ContentInfo
                    title='Cadastros em andamento'
                    description='Você começou, mas não finalizou um ou mais cadastros. Então listamos ele(s) aqui ao lado para que você continue-o(s).'>

                    <ul className={css.list}>
                        {this.state.list.map(i => (
                            <li key={i.id} style={{ opacity: i.deleting ? 0.3 : 1 }}>
                                <Row alignItems="center">
                                    <Col size='12 12 8'>
                                        <div style={{ marginBottom: '20px' }}>
                                            {i.experienceTypeLabel && (
                                                <Tag type='dark'>{i.experienceTypeLabel}</Tag>
                                            )}
                                            {i.experienceSubtypes && i.experienceSubtypes[0] && (
                                                <Tag type='dark'>{i.experienceSubtypes[0].nameBr}</Tag>
                                            )}
                                        </div>
                                        <Display size={3}>
                                            {i.title}
                                        </Display>
                                        <br />
                                        {i.city && i.state && (
                                           <span>
                                               <FontIcon name='pin' color='#f50' /> {i.city}, {i.state}
                                            </span>
                                        )}
                                    </Col>
                                    <Col size='12 12 4' text='center center right' style={{ marginTop: '15px' }}>
                                        {i.status === 2 ? (
                                            <Button secondary disabled inline onClick={() => this.props.history.push(`/create/experience/done/${i.token}`)}>Em análise</Button>
                                        ) : (
                                            i.status === 3 ? (
                                                <RouterLink to={`/create/experience/continue/${i.token}`}>
                                                    <Button primary inline>Finalizar cadastro</Button>
                                                </RouterLink>
                                            ) : (
                                                <Button primary inline onClick={() => this.props.onContinue(i.token)}>Continuar</Button>
                                            )
                                        )}

                                        {i.status === 1 && (
                                            <span className={css.iconBtn}>
                                                <ActionBtnIcon
                                                    icon='trash'
                                                    theme='rounded-orange'
                                                    action={() => this.remove(i.token)} />
                                            </span>
                                        )}
                                    </Col>
                                </Row>
                            </li>
                        ))}
                    </ul>
                </ContentInfo>

                <Dialog ref={ref => this.dialog = ref} />
            </div>
        )
    }

}

const mapStateToProps = store => ({
    user: store.user
})
const mapDispatchToProps = {
}
export default withRouter(connect( mapStateToProps, mapDispatchToProps )(ExperiencesList))


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/ExperiencesList/index.js